import __var_0__ from '@stdlib/assert/is-positive-number';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isPositiveNumber = __var_0__.isPrimitive;


// MAIN //

/**
* Validates `height`.
*
* @private
* @param {*} v - value to test
* @returns {(Error|null)} error object or null
*/
function test( v ) {
	if ( !isPositiveNumber( v ) ) {
		return new TypeError( 'invalid value. `height` must be a positive number. Value: `' + v + '.`' );
	}
	return null;
}


// EXPORTS //
export default test;
